import React from "react";

export const VehiclePlaceSceduleTable = ({ lineItem }) => {

    const schedules = lineItem?.vehicle_placement_schedule || [];

    const formatDateTime = (time) => {
        if (!time) return "NA";
        return new Date(time).toLocaleString();
    };

    return (
        <div>
            <div className="flex flex-row flex-between">
                <span className="section-sub-header-color fBold fs-16">
                    Vehicle Placement Schedule
                </span>
            </div>

            <div className="flex pv-20 border-bottom-light flex-between flex-middle">
                <div className="flex flex-1 col-6">
                    <span className="section-sub-header-color fBold fs-14 op-5">
                        Placement Time
                    </span>
                </div>

                <div className="flex flex-1 col-6">
                    <span className="section-sub-header-color fBold fs-14 op-5">
                        Vehicle Count
                    </span>
                </div>
            </div>

            {schedules.length === 0 && (
                <div className="pv-15 fs-14 op-5">No Schedule Available</div>
            )}

            {schedules.map((item, index) => (
                <div
                    className="flex pv-20 border-bottom-light flex-between flex-middle"
                    key={index}
                >
                    <div className="flex flex-1 col-6">
                        <span className="section-sub-header-color fs-14">
                            {formatDateTime(item.placement_time)}
                        </span>
                    </div>

                    <div className="flex flex-1 col-6">
                        <span className="section-sub-header-color fs-14">
                            {item.vehicle_count || 0}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    );
};